/** D19 乌云(安全事件):违规弹幕转化成无害幽默画面;不改全局天空。 */
import { Graphics } from 'pixi.js';
import { BaseEffect } from './base';
import { eventPool } from '../engine/ParticlePool';
import { scene } from '../engine/Scene';
import { TEX } from '../engine/Tex';
import { P } from '../engine/Palette';
import { LW, LH } from '../engine/Stage';
import { rand } from '../engine/util';

export class DarkCloudEffect extends BaseEffect {
  id = 'dark_cloud';
  private cloud = new Graphics(); private dir = 1; private dripT = 0;
  constructor() { super(); this.layerName = 'mistLayer'; }
  onStart() {
    this.dur = 10; this.tail = 1;
    this.dir = Math.random() < 0.5 ? 1 : -1;
    this.g.addChild(this.cloud);
    this.cloud.y = LH * 0.28;
    this.cloud.x = this.dir > 0 ? -260 : LW + 260;
    scene.crowd?.pray(this.dur);      // 烛民撑伞躲避(近似)
  }
  onUpdate(dt: number) {
    this.cloud.x += (this.dir * (LW + 520) / this.dur) * dt;
    const c = P.danger;
    this.cloud.clear();
    this.cloud.ellipse(0, 0, 120, 44).fill({ color: c, alpha: 0.92 });
    this.cloud.ellipse(-70, 10, 64, 30).fill({ color: c, alpha: 0.92 });
    this.cloud.ellipse(80, 8, 74, 34).fill({ color: c, alpha: 0.92 });
    this.cloud.alpha = this.env(1.5);
    this.dripT -= dt;
    if (this.dripT <= 0) {
      this.dripT = rand(0.3, 0.8);
      eventPool?.spawn({ x: this.cloud.x + rand(-80, 80), y: this.cloud.y + 30, vy: 120, life: 0.6, scaleX: 0.22, scaleY: 0.22, tint: c, alpha: 0.7, texture: TEX.streak() });
    }
  }
}
